<div class="form-row mb-2">
  <!-- Test Title -->
  <div [ngClass]="{'col-7': test.status != TestStatus.Active, 'col-4': test.status == TestStatus.Active}">
    <p style="padding-left: 30px;">{{ test.title }}</p>
  </div>

  <!-- Test Status -->
  <ng-container [ngSwitch]="test.status">
    <!-- Active -->
    <ng-container *ngSwitchCase="TestStatus.Active">
      <!-- Remaining Days  -->
      <ng-container *ngIf="!isFutureDate(test.scheduledStartTime) && certificationPurchased">
        <div class="col-0" >
            <img src="../../../../../assets/images/RemainingDays.svg" style="width:24px;height:24px;">
        </div>
        <div class="col-3">
          <strong><span class="text-muted">{{ 'Dashboard.ActiveCertification.RemainingDays' | translate }}: {{ test.expiryDate | tminus: 'days' }}</span></strong>
        </div>
      </ng-container>

      <!-- Scheduled Start Date  -->
      <div class="col-5" *ngIf="isFutureDate(test.scheduledStartTime) && certificationPurchased">
        <mat-icon class="align-middle">today</mat-icon>
        <b>
          {{ 'VideoConference.ScheduledDate' | translate }}
        </b>
        <span *ngIf="isFutureDate(test.scheduledStartTime)">
          {{ test.scheduledStartTime | kortoDateTime }}
        </span>
        <span *ngIf="test.isSpeakingTest && !test.scheduledStartTime">
          {{ 'VideoConference.PendingConfirmation' | translate }}
        </span>
      </div>
    </ng-container>
    <div class="col-3" *ngSwitchCase="TestStatus.Started">
      <!-- Started -->
      <strong class="text-danger"
        ><mat-icon class="align-middle">timer</mat-icon><span translate="Dashboard.ActiveCertification.Started"></span
      ></strong>
    </div>
    <div class="col-3" *ngSwitchCase="TestStatus.Submitted">
      <!-- Submitted -->
      <img src="../../../../../assets/images/Submitted.svg" style="width:24px;height:24px;">
      <strong class="text-muted" style="padding-left: .8em;" translate="Dashboard.ActiveCertification.Submitted"></strong>
    </div>
    <div class="col-3" *ngSwitchCase="TestStatus.Expired">
      <!-- Expired -->
      <strong class="text-danger"
        ><img src="../../../../../assets/images/Expired.svg" style="width:24px;height:24px;"><span style="padding-left: .8em;" translate="Dashboard.ActiveCertification.Expired"></span
      ></strong>
    </div>
      <!-- Completed -->
    <ng-container
      class="col-3"
      *ngSwitchCase="TestStatus.Completed"
      [class.completed-certification-test-item]="certificationCompleted"
    >
      <div class="col-0" style="padding-right: unset;">
        <img src="../../../../../assets/images/Score.svg" style="width:24px;height:24px;">
      </div>
      <div class="col-3">
        <strong>
          <span style="padding-left: .2em;">{{ 'Test.Score' | translate }}:&nbsp;</span>
          <span>{{ scores.label(test.score, test.language) }}</span>
        </strong>
      </div>
    </ng-container>
  </ng-container>

  <!-- Actions -->

  <div
    class="col-auto"
    *ngIf="test.isEvaluatorScheduleRequired && !test.scheduledStartTime; else elseBlock"
    translate="Dashboard.SchedulingRequired"
  ></div>

  <ng-template #elseBlock>
    <div class="col-auto" *ngIf="canAccess">
      <span>
        <!-- Instructions -->
        <a
        *ngIf="canShowTestInstruction()"
        class="text-right text-primary ml-2"
        [routerLink]="['/exam/', test.id]"
        [hidden]="isFutureDate(test.scheduledStartTime)"
        style="width: auto; margin-right: 20px;"
        >
        <img src="../../../../../assets/images/Instructions.svg" style="width:24px;height:24px;">
        <span style="padding-left: .2em;" translate="Dashboard.ActiveCertification.Instructions"></span>
        </a>
        <!-- Access -->
        <a
        *ngIf="test.status === TestStatus.Active || test.status === TestStatus.Started"
        class="btn btn-primary btn-sm ml-2"
        [routerLink]="['/exam/', test.id]"
        [hidden]="isFutureDate(test.scheduledStartTime)"
        style="width: auto"
        >
        <span translate="Dashboard.ActiveCertification.Access"></span>
        </a>
      </span>
    </div>
  </ng-template>
</div>
